import React from 'react'
import PlateMandalaComponent, { PlateMandalaPlaceholderComponent } from './PlateMandalaComponent'

import './Plate.css'
import Mandala from '../model/Mandala'
import rawMandalas from '../Mandalas'

const mandalas = rawMandalas.map( rawMandala => {
  return Mandala.withTitle(rawMandala.title)
})

const PlateComponent = (props) => {
  const range = [...Array(mandalas.length).keys()]

  return (
    <div className="Plate">
    {
      range.map( i => {
        const mandala = mandalas[i]
        return <div className="Plate-item" key={i}>{ mandala ? <PlateMandalaComponent key={i} {...mandalas[i]}/> : <PlateMandalaPlaceholderComponent /> }</div>
      })
    }
    </div>
  )
}

export default PlateComponent



/** WEBPACK FOOTER **
 ** ./src/components/PlateComponent.js
 **/